import React, { Component } from "react";
import { Col } from "react-bootstrap";
import { Api } from "../utils/api";

import { PaymentDetailsForm } from "./forms/payment-details.form";
import { PlanDetailsCard } from "../components/plan_detail_card.component";
import { withRouter } from "react-router";
import Typography from "@material-ui/core/Typography/Typography";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import PaymentItemsTable from "./components/payment_items_table.component";

class PaymentRequestView extends Component {
  state = {
    easypayReference: null,
    easypayPayment: null,
    nextEasypayPayments: null,
    totalDebt: 0,
    entityPlan: null,
  };

  constructor() {
    super();
    this.api = new Api();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getEasypayReference = this.getEasypayReference.bind(this);
    this.getEntityPlan = this.getEntityPlan.bind(this);
    this.getEasypayPayment = this.getEasypayPayment.bind(this);
    this.getNextEasypayPayments = this.getNextEasypayPayments.bind(this);
    this.getTotalDebt = this.getTotalDebt.bind(this);
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    if (id === "new") {
      this.setState({ easypayReference: {} });
      this.setState({ easypayPayment: {} });
      this.setState({ nextEasypayPayments: {} });
      return;
    }
    //
    return this.getEasypayPayment(id).then((data) => {
      const easypay_reference_id = data.easypay_reference_id;
      this.getEasypayReference(easypay_reference_id);
      this.getNextEasypayPayments(easypay_reference_id);
      this.getEntityPlan(easypay_reference_id);
    });
  }

  getEasypayPayment(id) {
    return this.api.get(`/easypay_payments/${id}`).then(({ data = null }) => {
      this.setState({ easypayPayment: data });
      return data;
    });
  }

  getEasypayReference(easypay_reference_id) {
    return this.api
      .get(`easypay_references`, { id: easypay_reference_id })
      .then(({ data = null }) => {
        this.setState({ easypayReference: data });
        return data;
      });
  }

  getEntityPlan(easypay_reference_id) {
    return this.api
      .get(`entity_plans`, { easypay_reference_id, last: true })
      .then(({ data = null }) => {
        if (!data) return;
        this.setState({ entityPlan: data });
        return data;
      });
  }

  getNextEasypayPayments(ep_reference_id, date) {
    return this.api
      .get(`easypay_payments`, {
        easypay_reference_id: ep_reference_id,
        payments_to_process: true,
      })
      .then(({ data = null }) => {
        this.setState({ nextEasypayPayments: data.easypay_payments });
        return data;
      });
  }

  handleSubmit(values, actions) {
    const { id } = this.props.match.params;
    if (id === "new") {
      return this.api
        .post(`easypay_payments/`, { ...values })
        .then(({ data: easypayPayment }) => {
          this.goTo(`/easypay_payments/${easypayPayment.ep_key}`);
          this.setState({ easypayPayment });
        });
    } else {
      return this.api
        .patch(`easypay_payments/${id}`, { ...values })
        .then(({ data: easypayPayment }) => this.setState({ easypayPayment }));
    }
  }

  getTotalDebt(payments = []) {
    const totalDebt = (payments ||[]).reduce((acc, payment) => {
      return acc + payment.ep_value;
    }, 0);

    return totalDebt.toFixed(2);
  }

  goTo(location) {
    this.props.history.replace(location);
  }

  render() {
    const easypayReference = this.state.easypayReference;
    const entityPlan = this.state.entityPlan;
    const easypayPayment = this.state.easypayPayment;
    const nextEasypayPayments = this.state.nextEasypayPayments;
    const totalDebt = this.getTotalDebt(nextEasypayPayments);

    return (
      <>
        <Col>
          {easypayReference && (
            <>
              <Typography variant="h6" color="#4682B4" gutterBottom>
                Subscrição
              </Typography>
              <PlanDetailsCard
                entity_plan={entityPlan}
                reference={easypayReference}
                handleSubmit={this.handleSubmit}
              />
            </>
          )}

          {easypayPayment && nextEasypayPayments && (
            <>
              <br></br>

              <Grid item md={5} style={{ marginTop: "20px" }}>
                <Typography variant="h6" color="#505e6b" gutterBottom>
                  Total em dívida:
                </Typography>
                <TextField
                  margin="normal"
                  id="description"
                  type="text"
                  variant="outlined"
                  value={totalDebt + "€"}
                  disabled={true}
                  style={{ marginTop: "0px" }}
                />
              </Grid>

              <PaymentDetailsForm
                onSubmit={this.handleSubmit}
                getForm={this.setForm}
                payment={easypayPayment}
                nextPayments={nextEasypayPayments}
              />

              <Grid md={12} style={{ marginTop: "10px" }}>
                <Typography variant="h6" color="#505e6b" gutterBottom>
                  Histórico cobranças
                </Typography>
                <PaymentItemsTable
                  easypay_reference_id={easypayPayment.easypay_reference_id}
                ></PaymentItemsTable>
              </Grid>
            </>
          )}
        </Col>
      </>
    );
  }
}

export default withRouter(PaymentRequestView);
